<template>
  <section>
    <template v-if="loading">
      <!-- Filter -->
      <div class="grid grid-cols-12 mt-8">
        <div class="col-span-6 lg:col-span-6 xxl:col-span-6">
          <h2 class="intro-y text-lg font-medium mr-auto mt-2">
            Biblioteca ({{ filteredLibraries.length }})
          </h2>
        </div>
        <div class="col-span-6 lg:col-span-6 xxl:col-span-6 mb-4 text-right">
          <a @click="create_modal = true"
            class="button text-white bg-theme-1 shadow-md mr-2">
            Crear Libreria
            </a>
        </div>
        <div class="col-span-6 lg:col-span-6 xxl:col-span-6 mb-2">
          <div class="col-span-6">
            <input type="text" class="input w-full border mt-2 flex-1"
              placeholder="Buscar por nombre..." v-model="filter.slug">
          </div>
        </div>
        <div class="col-span-12 lg:col-span-12 xxl:col-span-12 mb-4">
          <p class="w-full">Filtrar por cualquiera de las siguientes categorías:</p>
          <div class="intro-y mt-2 flex flex-wrap">
              <button class="button border-theme-5 border flex mr-1 mb-2"
                :class="{'bg-theme-1 text-white': filter.category == null}"
                @click="setCategory(null)">
                <app-icon name="layers" classname="w-4 h-4 mr-2 mt-1" />
                Todas las categorías
              </button>
              <button class="button border-theme-5 border flex mr-1 mb-2"
                :class="{'bg-theme-1 text-white': categoryMenu.name == filter.category}"
                @click="setCategory(categoryMenu.name)"
                v-for="categoryMenu in categories" :key="`category-${categoryMenu.name}`">
                <app-icon :name="categoryMenu.icon ? categoryMenu.icon : 'file'" classname="w-4 h-4 mr-2 mt-1" />
                {{categoryMenu.name}}
              </button>
          </div>
        </div>
        <div class="col-span-12 lg:col-span-12 xxl:col-span-12 mb-4">
            <p class="w-full">Filtrar por cualquiera de los siguientes equipos:</p>
            <div class="intro-y mt-2 flex flex-wrap">
                <button class="button border-theme-5 border flex mr-1 mb-2"
                  :class="{ 'bg-theme-1 text-white': filter.team == null }"
                  @click="setTeam(null)">
                  <app-icon name="layers" classname="w-4 h-4 mr-2 mt-1" />
                  Todos los equipos
                </button>
                <button class="button border-theme-5 border flex mr-1 mb-2"
                  :class="{ 'bg-theme-1 text-white': teamMenu.id == filter.team }"
                  @click="setTeam(teamMenu.id)"
                  v-for="teamMenu in teams" :key="`team-${teamMenu.name}`">
                  {{ teamMenu.name }}
                </button>
            </div>
          </div>
      </div>
      <!-- END: Filter -->

      <!-- List -->
      <div class="overflow-auto">
        <table class="table table-report -mt-2">
          <thead>
            <tr>
              <th class="text-center whitespace-no-wrap">NOMBRE</th>
              <th class="text-center whitespace-no-wrap">CATEGORÍA</th>
              <th class="text-center whitespace-no-wrap">VISUALIZACIÓN</th>
              <th class="text-center whitespace-no-wrap">URL</th>
              <th class="text-center whitespace-no-wrap">ESTADO</th>
              <th class="text-center whitespace-no-wrap">CREADO POR</th>
              <th class="text-center whitespace-no-wrap">ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr class="intro-x" v-for="library in filteredLibraries" :key="`library-${library.id}`">
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">{{library.name}}</div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">{{library.category}}</div>
              </td>
              <td class="w-40 text-center">
                  <div class="text-gray-600 text-xs whitespace-no-wrap">{{ library.team.name }}</div>
                </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  <a v-if="library.url" :href="library.url" target="_blank">
                    ver link
                  </a>
                </div>
              </td>
              <td class="w-40 text-center">
                  <div class="text-gray-600 text-xs whitespace-no-wrap">{{ library.status }}</div>
              </td>
              <td class="w-40 text-center">
                  <div class="text-gray-600 text-xs whitespace-no-wrap">{{ library.team_created_by.name }}</div>
              </td>
              <td class="table-report__action w-56">
                <div class="flex justify-center items-center">
                  <a @click="editModal(library)" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md">
                    <app-icon name="folder" classname="w-4 h-4 mr-2" />Editar
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- END: List -->
    </template>

    <app-loading v-else />

    <ModalCreateLibrary v-if="create_modal"
      :categories="categories"
      :teams="teams"
      @created="libraryCreated"
      @close="create_modal = false" />

    <ModalEditLibrary v-if="edit_modal"
      :library_current="library_current"
      :categories="categories"
      :teams="teams"
      @edited="libraryEdited"
      @close="edit_modal = false" />
  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Icon from '@/components/admin/partials/Icon'
  import Loading from '@/components/admin/partials/LoadingWhite'
  import ModalCreateLibrary from '@/components/admin/library/ModalCreateLibrary'
  import ModalEditLibrary from '@/components/admin/library/ModalEditLibrary'

  export default {
    name: 'AdminListLibrary',
    data () {
      return {
        loading: false,
        boxedit: false,
        library_current: {},
        create_modal: false,
        edit_modal: false,
        categories: [],
        filter: {
          slug: null,
          category: null,
          team: null,
        }
      }
    },
    computed: {
      ...mapGetters({
        libraries: 'getLibraries',
        accounts: 'getAccounts',
        teams: 'getTeams'
      }),
      filteredLibraries() {
        let items = this.libraries.filter(library => {
          let category = this.filter.category ? library.category == this.filter.category : true;
          let team = this.filter.team ? library.team_createdby_id == this.filter.team : true;
          let slug = this.filter.slug ? library.name.toLowerCase().includes(this.filter.slug.toLowerCase()) : true;

          return category && team && slug;
        })

        return items
      }
    },
    async beforeMount () {
      try {
        await this.getList('account')
        const { categories } = await this.getAll('library')
        this.categories = categories

        this.loading = true
      } catch (error) {}
    },
    methods: {
      setCategory(name) {
        this.filter.category = name
        console.log(this.filter)
      },
      setTeam(name) {
        this.filter.team = name
        console.log(this.filter)
      },
      libraryCreated() {
        this.create_modal = false
        this.getAll('library')
      },
      libraryEdited() {
        this.library_current = {}
        this.edit_modal = false
        this.getAll('library')
      },
      editModal(library) {
        this.library_current = library
        this.edit_modal = true
      },
      ...mapActions([
        'getList',
        'getAll'
      ])
    },
    components: {
      appIcon: Icon,
      appLoading: Loading,
      ModalCreateLibrary,
      ModalEditLibrary
    },
  }
</script>



// WEBPACK FOOTER //
// ListLibrary.vue?77435b43